import { parsePostcode } from './addAddressHelper';

const PARAM_ALIASES = {
  AddressNum: 'AddressNumber',
  AddressNumPrefix: 'AddressNumberPrefix',
  AddressNumSuffix: 'AddressNumberSuffix',
  CityDescription: 'ptsCityID',
};

export const getAddressDuplicateParams = (rules = []) =>
  rules
    .map((rule) => rule.Path?.split('.').pop())
    .filter((key) => key && key !== 'CheckForDuplicates' && key !== 'UnitIdentifier')
    .map((key) => PARAM_ALIASES[key] || key);

export const buildAddressDuplicateQuery = (values) => {
  const postal = parsePostcode(values.Postal);
  return {
    AddressNumber: values.AddressNumber || null,
    AddressNumberPrefix: values.AddressNumberPrefix || null,
    AddressNumberSuffix: values.AddressNumberSuffix || null,
    StreetName: values.StreetName || null,
    StreetType: values.StreetType || null,
    PostDirection: values.PostDirection || null,
    PreDirection: values.PreDirection || null,
    ptsCityID: values.ptsCityID || null,
    State: values.State || null,
    PostalCode: postal.PostalCode || null,
    PostalCodeExtension: postal.PostalCodeExtension || null,
  };
};

export const hasAddressDuplicateParams = (params, query) =>
  params.length > 0 && params.every((key) => query[key] !== null && query[key] !== undefined);
